<template>
  <layout-vertical v-if="isAuthenticated">
    <router-view />
    <template #navbar="{ toggleVerticalMenuActive }">
      <navbar :toggle-vertical-menu-active="toggleVerticalMenuActive" />
    </template>

    <!-- <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    /> -->
  </layout-vertical>
</template>

<script>
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
// import { $themeConfig } from '@themeConfig'
import Navbar from '../components/Navbar.vue'

export default {
  components: {
    // AppCustomizer,
    LayoutVertical,
    Navbar,
  },
  data() {
    return {
      // showCustomizer: $themeConfig.layout.customizer,
      isAuthenticated: false,
    }
  },
  created() {
    sessionStorage.getItem('token') ? this.isAuthenticated = true : this.isAuthenticated = false

    const [zenviaChat] = document.getElementsByClassName('znv-float-button')

    if (this.isAuthenticated && zenviaChat) {
      zenviaChat.style.display = 'block'
    } else if (zenviaChat) {
      zenviaChat.style.display = 'none'
    }
  },
}
</script>
<style>
.znv-float-button {
  display: block;
  margin-bottom: 50px;
}
</style>
